import { formatDate } from "./TableAddPayments";

function LoadsInProgress({ orderItems }) {
  if (!orderItems) return;

  const quantities = orderItems.flatMap((item) => {
    if (item.Order_Loads_Item?.length > 0) {
      return item.Order_Loads_Item.map((orderLoadItem) => {
        const loadingDate = new Date(orderLoadItem.order_load.loading_date);
        console.log("loading date: ", loadingDate);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        loadingDate.setHours(0, 0, 0, 0);
        return loadingDate <= today ? 0 : orderLoadItem.quantity;
      });
    }
  });

  const totalQuantity = quantities
    .filter((q) => q !== undefined)
    .reduce((prev, next) => prev + next, 0);

  return (
    <div className="w-[50%]">
      <div className="flex gap-4 items-center justify-between">
        <p className="text-lg font-semibold mt-6 mb-4">Cargas em Andamento</p>
        <div className="text-sm border border-black rounded-md px-2 py-1 mt-3">
          <div className="flex gap-2">
            <p className="font-semibold">ITENS COMPRADOS:</p>
            <span> {totalQuantity} unidades</span>
          </div>
        </div>
      </div>
      <div className="bg-gray-100 pt-2 rounded-md">
        <div className="overflow-hidden">
          <table className="w-full border-separate border-spacing-y-4">
            <thead>
              <tr>
                <th className="w-[30%] text-left pl-4">Carga</th>
                <th className="w-[15%] text-center">QTD</th>
                <th className="w-[20%] text-center">Preço Médio</th>
                <th className="w-[15%] text-center">Status</th>
                <th className="w-[18%] text-center pr-6">Previsão</th>
              </tr>
            </thead>
          </table>
        </div>
        <div className="relative max-h-80 overflow-y-auto custom-scrollbar">
          <table className="w-full border-separate border-spacing-y-4">
            <tbody>
              {orderItems.map((item) => (
                <>
                  {item.Order_Loads_Item?.length > 0
                    ? item.Order_Loads_Item.map((orderLoadItem) => {
                        const loadingDate = new Date(
                          orderLoadItem.order_load.loading_date
                        );
                        const today = new Date();
                        today.setHours(0, 0, 0, 0);
                        loadingDate.setHours(0, 0, 0, 0);

                        if (loadingDate <= today) return null;
                        return (
                          <tr
                            key={orderLoadItem.order_load.id}
                            className="bg-gray-200 rounded-lg"
                          >
                            <td className="w-[30%] text-left pl-4 py-4">
                              {`TIA00${orderLoadItem.order_load.id}-${
                                formatDate(
                                  orderLoadItem.order_load.loading_date
                                ).split("/")[2]
                              }`}
                            </td>
                            <td className="w-[15%] text-center">
                              {orderLoadItem.quantity}
                            </td>
                            <td className="w-[20%] text-center">
                              $ 4,68 ($ 1,50)
                            </td>
                            <td className="w-[15%] text-center">1515</td>
                            <td className="w-[15%] text-center pr-4">
                              {formatDate(
                                orderLoadItem.order_load.loading_date
                              )}
                            </td>
                          </tr>
                        );
                      })
                    : ""}
                </>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
export default LoadsInProgress;
